import React from 'react';
import {connect} from 'react-redux'
import bn from '../../utils/bemnames';
import {Navbar, Nav, NavItem, NavLink, Popover, PopoverBody, ListGroup, ListGroupItem, Button,} from 'reactstrap';
import {MdNotificationsActive, MdNotificationsNone, MdClearAll, MdExitToApp,} from 'react-icons/lib/md';
import Avatar from '../../components/Avatar';
import {UserCard} from '../../components/Card';
import Notifications from '../../components/Notifications';
import withBadge from '../../hocs/withBadge';
import {bindActionCreators} from "redux";
import {logout} from "../../actions/userAction";
import {withRouter} from "react-router";

const notificationsData = [];

const bem = bn.create('header');

const MdNotificationsActiveWithBadge = withBadge({
    size: 'md',
    color: 'primary',
    style: {
        top: -10,
        right: -10,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    children: <small>5</small>,
})(MdNotificationsActive);

class Header extends React.Component {
    state = {
        isOpenNotificationPopover: false,
        isNotificationConfirmed: false,
        isOpenUserCardPopover: false,
    };

    toggleNotificationPopover = () => {
        this.setState({
            isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
        });

        if (!this.state.isNotificationConfirmed) {
            this.setState({isNotificationConfirmed: true});
        }
    };

    toggleUserCardPopover = () => {
        this.setState({
            isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
        });
    };

    handleSidebarControlButton = event => {
        event.preventDefault();
        event.stopPropagation();

        document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
    };

    onLogout = () => {
        this.props.logout();
        setTimeout(() => {
            this.props.history.push('/login');
        }, 1000);
    };

    render() {
        const {isNotificationConfirmed} = this.state;
        const {user} = this.props;
        return (
            <Navbar light expand className={bem.b('bg-white') + ' shadow-sm'}>
                <Nav navbar className="mr-2">
                    <Button outline onClick={this.handleSidebarControlButton}>
                        <MdClearAll size={25}/>
                    </Button>
                </Nav>

                <Nav navbar>

                </Nav>

                <Nav navbar className={bem.e('nav-right')}>
                    <NavItem>
                        <NavLink id="Popover2" onClick={this.toggleUserCardPopover} className="can-click">
                            <Avatar/>
                            {user && user.name}
                        </NavLink>
                        <Popover
                            placement="bottom-end"
                            isOpen={this.state.isOpenUserCardPopover}
                            toggle={this.toggleUserCardPopover}
                            target="Popover2"
                            className="p-0 border-0 custom-popover"
                            style={{minWidth: 250}}>
                            <PopoverBody className="p-0 border-light">
                                <UserCard
                                    title={user && user.name}
                                    subtitle={user && user.email}
                                    className="border-light">
                                    <ListGroup flush>
                                        <ListGroupItem tag="button" action
                                                       onClick={this.onLogout}
                                                       className="border-light cursor">
                                            <MdExitToApp/> Logout
                                        </ListGroupItem>
                                    </ListGroup>
                                </UserCard>
                            </PopoverBody>
                        </Popover>
                    </NavItem>
                </Nav>
            </Navbar>
        );
    }
}

const mapStateToProps = state => {
    return {user: state.userReducer.user};
};

const mapDispatchToProps = dispatch =>
    bindActionCreators({logout: logout}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));




// WEBPACK FOOTER //
// ./src/components/Layout/Header.js